import React, { useEffect, useState } from 'react';
import { Sparkles } from 'lucide-react';
import { useShowFinder } from '../contexts/ShowFinderContext';

const SESSION_KEY = 'baadtv_show_finder_later';

const ShowFinderBanner = () => {
  const { status, openWizard, dismiss } = useShowFinder();
  const [hiddenForSession, setHiddenForSession] = useState(false);

  // "Later" hides the banner just for this browser session — no API call.
  // Re-checked on mount so existing tabs stay hidden.
  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY) === '1') {
      setHiddenForSession(true);
    }
  }, []);

  const handleLater = () => {
    sessionStorage.setItem(SESSION_KEY, '1');
    setHiddenForSession(true);
  };

  // Hide if loading, completed, dismissed permanently, or user clicked "Later"
  if (!status || status.completed || status.dismissed || hiddenForSession) return null;

  return (
    <div className="sf-banner" data-testid="show-finder-banner">
      <div className="sf-banner-inner">
        <div className="sf-banner-icon"><Sparkles size={18} /></div>
        <div className="sf-banner-text">
          <div className="sf-banner-title">Find shows you'll love</div>
          <div className="sf-banner-sub">Pick a few genres and we'll suggest popular shows to add</div>
        </div>
        <button
          className="sf-banner-cta"
          onClick={openWizard}
          data-testid="show-finder-banner-open"
        >
          Get started
        </button>
      </div>

      <div className="sf-banner-links">
        <button
          className="sf-banner-link"
          onClick={handleLater}
          data-testid="show-finder-banner-later"
        >
          Later
        </button>
        <span className="sf-banner-link-sep">·</span>
        <button
          className="sf-banner-link sf-banner-link-dismiss"
          onClick={dismiss}
          data-testid="show-finder-banner-dismiss"
        >
          Dismiss
        </button>
      </div>

      <style>{`
        .sf-banner {
          background: linear-gradient(135deg, rgba(230, 47, 136, 0.15) 0%, rgba(230, 47, 136, 0.05) 100%);
          border: 1px solid rgba(230, 47, 136, 0.4);
          border-radius: 12px;
          padding: 0.85rem 1rem 0.65rem;
          margin-bottom: 1rem;
        }
        .sf-banner-inner {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          flex-wrap: wrap;
        }
        .sf-banner-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: rgba(230, 47, 136, 0.2);
          color: #E62F88;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .sf-banner-text {
          flex: 1;
          min-width: 200px;
        }
        .sf-banner-title {
          color: #fff;
          font-weight: 600;
          font-size: 0.95rem;
        }
        .sf-banner-sub {
          color: #bbb;
          font-size: 0.82rem;
          margin-top: 0.1rem;
        }
        .sf-banner-cta {
          background: #E62F88;
          color: #fff;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 8px;
          font-weight: 600;
          font-size: 0.85rem;
          cursor: pointer;
          transition: background 0.15s;
        }
        .sf-banner-cta:hover {
          background: #c4226c;
        }
        .sf-banner-links {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          justify-content: flex-end;
          margin-top: 0.45rem;
        }
        .sf-banner-link {
          background: transparent !important;
          border: none !important;
          color: #E62F88 !important;
          font-size: 0.78rem;
          font-weight: 600;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          cursor: pointer;
          padding: 0.25rem 0.4rem;
          border-radius: 0;
          appearance: none;
          -webkit-appearance: none;
          transition: color 0.15s, opacity 0.15s;
        }
        .sf-banner-link:hover,
        .sf-banner-link:focus,
        .sf-banner-link:active {
          color: #ff6b8a !important;
          background: transparent !important;
          opacity: 0.85;
          filter: none !important;
          text-decoration: underline;
        }
        .sf-banner-link.sf-banner-link-dismiss,
        .sf-banner-link.sf-banner-link-dismiss:hover {
          color: #E62F88 !important;
        }
        .sf-banner-link-sep {
          color: #555;
          font-size: 0.78rem;
        }
      `}</style>
    </div>
  );
};

export default ShowFinderBanner;
